import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { PackStatusRequest } from '../api/packstatus/packstatusrequest';
import { PackStatusResponse, PackStatusResponseDtoImpl } from '../api/packstatus/packstatusresponse';
import { PackStatusBuilder } from '../dto/packstatus/packstatusbuilder';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class PackStatusAPIProcessorImpl extends SixdeeCRBTAPIProcessor<PackStatusRequest, PackStatusResponse>
{

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try{
            
            if(+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
            {
                let response = new PackStatusResponseDtoImpl(APIFeatures.PACK_STATUS , "Pack Status Successful");
                response.setPackStatusDto(new PackStatusBuilder(responseMapper.getResponseMap(), this.getContext()).buildAll());

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new PackStatusResponseDtoImpl(APIFeatures.PACK_STATUS, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new PackStatusResponseDtoImpl(APIFeatures.PACK_STATUS, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch(e)
        {
            this.getAPIFailure(new PackStatusResponseDtoImpl(APIFeatures.PACK_STATUS, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
      
                this.getAPIFailure(new PackStatusResponseDtoImpl(APIFeatures.PACK_STATUS, responseMapper.getStatusMsg()));
            
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/packstatusapiprocessor.tsx